import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api.ts";

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        // Keep visited pages in memory across a break. Mount/focus still
        // refreshes stale data, without replacing it with a full-page skeleton.
        // Session changes clear and workspace switching resets the client;
        // nothing is persisted.
        gcTime: 30 * 60_000,
        refetchOnWindowFocus: true,
        // Not signed in, not found and refused are answers, not hiccups.
        retry: (count, error) => !(error instanceof ApiError && [400, 401, 403, 404].includes(error.status)) && count < 2,
      },
    },
  });
}
